import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Field, reduxForm, getFormValues} from 'redux-form';
import {withStyles} from '@mui/styles';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import {
  Stack,
  FormControl,
  FormGroup,
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import {isEmpty} from '@grapecity/wijmo';
import {HttpStatusCode} from 'axios';
import {commonOperations} from '../../../../reducks/common/index.js';
import MainContainer from '../../../organisms/MainContainer.js';
import {renderTextField, renderNoticeArea, renderSelect, renderCheckbox} from '../../../atoms/CustomPart.js';
import CustomFlexGrid, {createComponents} from '../../../molecules/CustomFlexGrid.js';
import PositiveButton from '../../../atoms/Buttons/PositiveButton.js';
import PaperPart from '../../../atoms/PaperPart.js';
import withRouter from '../../../organisms/withRouter.js';
import {requiredCheck, mailCheck, dateCheck, timeCheck, errorResult, dateFromToCheck} from '../../../../common/inputCheck.js';
import WarningMessageArea from '../../../molecules/WarningMessageArea.js';
import CustomBreadcrumbs from '../../../molecules/Breadcrumbs.js';
import {GMN, GMN_PATH, CATEGORY_TYPE, SEARCHRESULT_MAX} from '../../../../common/commonConst.js';
import {searchMap, formatStringDate} from '../../../../common/common.js';
import {getKbnList, sysErr} from '../../../../common/commonGmn.js';
import {postRequest} from '../../../../common/backend.js';
// パンくずパラメータ
const transitionList = [
  {gmnName: GMN.MENU.name, href: GMN_PATH.MENU},
  {gmnName: GMN.SYSTEM_SETTING.name, href: ''},
];

const styles = (theme) => ({

  noticeArea: {
    width: '90%',
    height: '248px',
    margin: '0 auto',
    marginBottom: 10,
    fontSize: '1.016em',
    borderRadius: '3px',
    border: '3px solid #4F89C6',
    background: 'white',
    padding: '4px 10px',
    overflow: 'scroll',
    userSelect: 'auto',
  },
});

const gridItems = [
  {binding: 'classification', header: '分類', dataType: 'String', width: 150},
  {binding: 'itemName', header: '項目名', dataType: 'String', width: 350},
  {binding: 'setting', header: '設定値', dataType: 'String', width: 300},
  {binding: 'description', header: '説明', dataType: 'String', width: 200},
  {binding: 'date', header: '適用年月日', dataType: 'String', width: 180},
  {binding: 'updateTime', header: '更新日時', dataType: 'String', width: 180, isReadOnly: true, visible: false},
];


/**
 * システム設定マスタ
 * 画面ID:SCZ1010
 */
class Container extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabIndex: 1,
      downloadBtnDisabled: true,
      updateBtnDisabled: true,
      deleteBtnDisabled: true,
      warningMessages: [],
      isSelectInformatiion: false,
      preview: '',
      isChanged: false,
      isStartEndReadOnly: false,
      mstData: {},
    };
    this.type = '';
    this.gridRef = React.createRef();
    this.isUpdate = false;
  }

  /**
   * 初期処理
   */
  async componentDidMount() {
    this.initialize();
  }
  /**
   * 画面項目初期化
   * @return {object} 画面項目
   */
  initialize = async () => {
    this.props.doSetInitValues(null);
    try {
      this.searchCondition = '';
      // リクエスト出す
      let _body = {
        searchCondition: null,
      };
      const response = await postRequest('scz1010/search-system-setting', _body);

      if (response.status != HttpStatusCode.Ok) {
        if (response.data?.message != null) {
          this.props.doShowMessage({
            message: {
              id: response.data?.message.id,
              text: response.data?.message.text,
            },
          });
        }
        return;
      }
      this.initializePage(response);
    } catch (error) {
      sysErr(this.props);
    }
  };

  /**
   * 終了処理
   */
  async componentWillUnmount() {
    this.props.reset();
  }

  /**
   * 入力チェック
   * @param {object} items 画面入力値
   * @return {array} エラーメッセージ
   */
  inputCheck = (items) => {
    let _warning = [];
    let resultList = [];

    // 必須チェック
    if (items.valueType !== 3) {
      resultList.push(requiredCheck('設定値', items.setting));
    } else {
      resultList.push(requiredCheck('設定値-日付', items.dateSetting));
      resultList.push(requiredCheck('設定値-時刻', items.timeSetting));
    }
    // 有期限場合、適用期間必須チェック、日付整合性チェック
    if (!items.isIndefinite) {
      const fromLabel='適用開始年月日';
      const toLabel ='適用終了年月日';
      resultList.push(requiredCheck(fromLabel, items.startYmd));
      resultList.push(requiredCheck(toLabel, items.endYmd));
      resultList.push(dateFromToCheck(fromLabel, items.startYmd,
          toLabel, items.endYmd));
    }
    switch (items.valueType) {
      case 1:
        // 数値チェック
        if (!isEmpty(items.setting) && !parseFloat(items.setting)) {
          resultList.push(errorResult('TKSCS00006E', ['設定値']));
        }

        // 上限値・下限値チェック
        if (!isEmpty(items.setting) &&
            items.upperLimit != null && items.lowerLimit != null &&
              (Number(items.setting) > items.upperLimit ||
              Number(items.setting) < items.lowerLimit)) {
          resultList.push(errorResult('TKSCS00039E', ['設定値', items.lowerLimit + '～' + items.upperLimit]));
        } else if (!isEmpty(items.setting) &&
            items.upperLimit != null &&
              Number(items.setting) > items.upperLimit) {
          resultList.push(errorResult('TKSCS00039E', ['設定値', items.upperLimit + '以下']));
        } else if (!isEmpty(items.setting) &&
            items.lowerLimit != null &&
              Number(items.setting) < items.lowerLimit) {
          resultList.push(errorResult('TKSCS00039E', ['設定値', items.lowerLimit + '以上']));
        }
        break;
      case 2:
        // 桁数チェック
        if (items.upperLimit != null && !isEmpty(items.setting) &&
            items.setting.length > items.upperLimit) {
          resultList.push(errorResult('TKSCS00009E', ['設定値', items.upperLimit]));
        }
        break;
      case 3:
        // 日付妥当性チェック
        resultList.push(dateCheck('設定値', items.dateSetting));
        // 時刻妥当性チェック
        resultList.push(timeCheck('設定値', items.timeSetting));
        break;
      case 7:
        // メールアドレスチェック
        resultList.push(mailCheck('設定値', items.setting));
        break;
      default:
        break;
    }
    for (const result of resultList) {
      if (result.error) {
        _warning.push(result.message);
      }
    }

    return _warning;
  };

  /**
   * 検索ボタン押下時
   */
  doSearch = async () => {
    try {
      let _url = 'scz1010/search-system-setting';
      let _body = {
        searchCondition: this.searchCondition,
      };
      const response = await postRequest(_url, _body);
      if (response.status != HttpStatusCode.Ok) {
        if (response.data?.message != null) {
          this.props.doShowMessage({
            message: {id: response.data?.message.id,
              text: response.data?.message.text},
          });
        }
        return;
      }
      this.setState({
        isChanged: false,
      });
      this.initializePage(response);
    } catch (error) {
      sysErr(this.props);
    }
  };

  /**
   * 初期化画面
   * @param {Object} response
   */
  initializePage = async (response) => {
    let _itemCount = 0;
    let _warningMessages = [];
    this.setState({warningMessages: _warningMessages});

    let listData = response.data?.mstList || [];
    this.setGridItems(listData);
    _itemCount = listData.length;
    this.setState({itemCount: _itemCount});
    if (_itemCount>SEARCHRESULT_MAX) {
      let message = {
        id: 'TKSCS00041E',
        values: [_itemCount, SEARCHRESULT_MAX],
      };
      _warningMessages.push(message);
      this.setState({warningMessages: _warningMessages});
    }
    // FlexGridに初期値設定
    if (this.gridRef?.current) {
      // システム設定一覧データを設定
      this.gridRef.current.setItemsSource(listData);

      if (!this.isUpdate) {
        // デフォルトデータの第一行を選択する
        this.gridRef.current.radioCheckId = 0;
        this.setEidtData(listData[0]);
      } else {
        let index = this.gridRef.current.radioCheckId;
        let _mstData = listData[index];
        // 検索条件変更した場合、データの第一行を選択する
        if (isEmpty(_mstData)) {
          this.gridRef.current.radioCheckId = 0;
          this.setEidtData(listData[0]);
        } else {
          this.setEidtData(_mstData);
          if (this.gridRef.current.selectedItems[0]) {
            this.gridRef.current.grid.select(
                this.gridRef.current.selectedItems[0]._idx, 0);
          } else {
            this.gridRef.current.grid.select(0, 0);
          }
        }
      }

      this.isUpdate = false;
    }
  };


  /**
   * システム設定一覧項目設定
   * @param {*} list システム設定データリスト
   */
  setGridItems = (list) => {
    for (const data of list) {
      switch (data['valueType']) {
        case 1:
          data['setting'] = data['valueNum'];
          break;
        case 3:
        case 4:
          if (!isEmpty(data['valueDateTime'])) {
            data['setting'] = formatStringDate(data['valueDateTime'], 'yyyy/MM/dd HH:mm:ss');
            data['dateSetting'] = data['setting'].substr(0, 10);
            data['timeSetting'] = data['setting'].substr(11, 5);
          }
          break;
        default:
          data['setting'] = data['valueString'];
          break;
      }
    }
  };

  /**
   * 編集データ設定
   * @param {*} selectData
   */
  setEidtData = (selectData) => {
    const {values} = this.props;
    let _selectData = {...selectData};
    switch (_selectData.valueType) {
      case 1:
        this.type = 'number';
        break;
      case 3:
        if (!isEmpty(_selectData.dateSetting)) {
          _selectData.dateSetting = _selectData.dateSetting.replaceAll('/', '-');
        }
        break;
      case 5:
        this.type = 'text';
        if (_selectData.setting == null) {
          _selectData.setting = '';
        }
        this.setPreview(_selectData.setting);
        break;
      default:
        this.type = 'text';
        break;
    }
    this.setState({
      updateBtnDisabled: !_selectData.changed,
      mstData: _selectData,
    });
    if (values!=null) {
      _selectData['classificationCode']=values.classificationCode;
    }
    this.props.doSetInitValues(_selectData);
  };

  /**
   * ラジオボタンチェック状態によりState更新
   */
  checkStateUpdate = () => {
    try {
      if (this.gridRef?.current &&
        this.gridRef.current.selectedItemCount() > 0) {
        let selectData = this.gridRef.current.selectedItem()[0].dataItem;
        this.setEidtData(selectData);
        if (selectData.isIndefinite) {
          this.setState({isStartEndReadOnly: true});
        } else {
          this.setState({isStartEndReadOnly: false});
        }
      }
      this.setState({warningMessages: []});
    } catch (error) {
      sysErr(this.props);
    }
  };

  /**
   * 更新ボタン押下時
   */
  doUpdate = () => {
    const {values} = this.props;
    let _warningMessages = this.inputCheck(values);
    this.setState({
      warningMessages: _warningMessages,
    });
    if (_warningMessages.length > 0) {
      this.props.doShowMessage({
        message: {id: 'TKSCS00012E', values: ['入力エラーの', '更新']},
      });
      return;
    }
    this.props.doShowMessage({
      message: {
        id: 'TKSCS00002C',
        values: ['更新'],
      },
      action: () => {
        this.updateAction();
      },
    });
  };

  /**
   * 更新処理
   */
  updateAction = async () => {
    const {values} = this.props;
    let _warningMessages = [];
    let _mstData = {...this.state.mstData};
    try {
      let _body = {
        data: _mstData,
        searchCondition: this.searchCondition,
      };

      _body.data.setting = values.setting;
      _body.data.description = values.description;
      _body.data.startYmd = values.startYmd;
      _body.data.endYmd = values.endYmd;
      _body.data.isIndefinite = values.isIndefinite;

      if (_mstData.valueType === 3) {
        _body.data.dateSetting = values.dateSetting;
        _body.data.timeSetting = values.timeSetting;
      }

      const response = await postRequest('scz1010/update-system-setting', _body);
      if (response.status != HttpStatusCode.Ok) {
        if (response.data?.detailMessages != null) {
          _warningMessages = response.data?.detailMessages;
        }
        if (response.data?.message != null) {
          this.props.doShowMessage({
            message: {id: response.data?.message.id,
              text: response.data?.message.text},
          });
        }
        return;
      }
      this.isUpdate = true;
      this.initializePage(response);
      this.props.doShowMessage({
        message: {id: 'TKSCS00004I', values: ['更新']},
      });
    } catch (error) {
      sysErr(this.props);
    } finally {
      this.setState({
        warningMessages: _warningMessages,
      });
    }
  };

  /**
   * 一覧表示
   * @return {object}
   */
  renderTable() {
    const props = {
      rowHeaderType: 'radio',
      filterOn: true,
      headersVisibility: 'Column',
      allowDragging: 'None',
      allowSorting: 'SingleColumn',
      AddDeleteOn: false,
      style: {maxHeight: 'auto', maxWidth: 'auto', height: '180px', width: 'auto', marginTop: '0px', marginLeft: '0px'},
      isReadOnly: true,
      isDisplayCount: true,
      checkedFunction: this.checkStateUpdate,
    };
    const component = createComponents(gridItems, true);
    return (
      <CustomFlexGrid ref={this.gridRef} {...props}>
        {component}
      </CustomFlexGrid>
    );
  }

  /**
   * フッタボタン
   * @return {JSX.Element}
   */
  renderFooterBtn() {
    const {
      handleSubmit,
    } = this.props;

    return (
      <Grid
        container
        justifyContent="center"
        alignItems="flex-start"
        spacing={1}
      >
        <Grid key="btnUpdate" item>
          <PositiveButton
            id="btnUpdate"
            onClick={handleSubmit(this.doUpdate)}
            variant="contained"
            startIcon={<SaveIcon/>}
            size="middle"
            disabled={this.state.updateBtnDisabled}
          >
            <span>更新</span>
          </PositiveButton>
        </Grid>
      </Grid>
    );
  };

  setPreview(item) {
    const {classes} = this.props;
    const preview = renderNoticeArea(classes.noticeArea, item);
    this.setState({
      preview: preview,
    });
  };

  /**
   * 検索条件変更
   * @param {*} e イベント
   * @param {*} val 値
   */
  handleOptionChange = (e, val) => {
    this.searchCondition = val;
  };

  /**
   * テキスト変更
   * @param {*} e
   * @param {*} v
   */
  textChange = (e, v) => {
    this.setState({isChanged: true});
  };

  /**
   * 画面遷移
   * @param {object} path 遷移パス
   */
  doMoveNext = async (path) => {
    if (this.state.isChanged) {
      this.props.doShowMessage({
        message: 'TKSCS00038W',
        action: () => {
          // OKを押すと画面遷移
          this.props.navigate(path);
        },
      });
    } else {
      // 編集されていない場合は確認なしで遷移
      this.props.navigate(path);
    }
  };

  /**
   * チェックボックス変更
   * @param {*} e
   * @param {*} v="isindefinite" type="c
   */
  chechBoxChange = (e, v) => {
    const {values} = this.props;
    if (e.target.checked) {
      values.startYmd=null;
      values.endYmd=null;
      this.setState({isStartEndReadOnly: true});
    } else {
      let selectData = this.gridRef.current.selectedItem()[0].dataItem;
      values.startYmd=selectData.startYmd;
      values.endYmd=selectData.endYmd;
      this.setState({isStartEndReadOnly: false});
    }
    this.setState({isChanged: true});
  };

  render() {
    const {classes,
      handleSubmit,
      genericMap} = this.props;
    let _mstData = {...this.state.mstData};
    const isDateTime = _mstData.valueType === 3;
    const isTextarea = _mstData.valueType === 5 || _mstData.valueType === 8;
    const isReadOnly = !_mstData.changed;
    // フッタボタンを生成
    const footerBtn = this.renderFooterBtn();
    const classificationList = searchMap(
        genericMap, CATEGORY_TYPE.CLASSIFICATION_CODE);
    let classificationCdList = getKbnList(classificationList);
    return (
      <form noValidate autoComplete="off" className={classes.root}>
        <MainContainer
          props={this.props}
          footerBtn={footerBtn}>
          <CustomBreadcrumbs key="keyBreadcrumbs" items={transitionList} move={this.doMoveNext}/>
          {this.state.warningMessages.length > 0 && <PaperPart>
            <Grid container
              justifyContent="flex-start"
              alignItems="flex-end"
            >
              <Grid key="MG012Msg" item xs={12}>
                <WarningMessageArea messages={this.state.warningMessages}/>
              </Grid>
              <Grid key="template" item xs={12}>
                <Typography variant='h6' sx={{fontWeight: 'bold'}}></Typography>
              </Grid>
            </Grid>
          </PaperPart>}
          <PaperPart>
            <Grid container
              justifyContent="flex-start"
              alignItems="flex-end"
            >
              <Grid key="classificationCode" item xs={12} sm={4}>
                <Stack direction="row">
                  <Field
                    id="classificationCode"
                    name="classificationCode"
                    component={renderSelect}
                    className="fields"
                    label="分類"
                    fullWidth
                    required={false}
                    validate={[
                    ]}
                    onChange={this.handleOptionChange}
                  >
                    {classificationCdList}
                  </Field>
                  <PositiveButton
                    id="search"
                    onClick={handleSubmit(this.doSearch)}
                    variant="contained"
                    size="middle"
                    className="fields"
                  >
                    <span>検索</span>
                  </PositiveButton>
                </Stack>
              </Grid>
              <Grid key="CO001List" item xs={12}>
                {this.renderTable()}
              </Grid>
            </Grid>
          </PaperPart>
          <PaperPart>
            <Grid container
              justifyContent="flex-start"
              alignItems="flex-end"
              spacing={1}
            >
              <Grid key="classification" item xs={12} sm={4}>
                <Field
                  id="classification"
                  name="classification"
                  component={renderTextField}
                  className="fields"
                  label="分類"
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </Grid>
            </Grid>
            <Grid container
              justifyContent="flex-start"
              alignItems="flex-end"
              spacing={1}
            >
              <Grid key="itemName" item xs={12} sm={4}>
                <Field
                  id="itemName"
                  name="itemName"
                  component={renderTextField}
                  className="fields"
                  label="項目名"
                  fullWidth
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </Grid>
              {isDateTime && <Grid container
                justifyContent="flex-start"
                alignItems="flex-end"
                spacing={1}
              >
                <Grid key="dateSetting" item xs={12} sm={2}>
                  <Field
                    id="dateSetting"
                    name="dateSetting"
                    component={renderTextField}
                    className="fields"
                    label="設定値"
                    required={true}
                    type={'date'}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                    onChange={this.textChange}
                    InputProps={{
                      readOnly: isReadOnly,
                    }}
                    validate={[
                    ]}
                  />
                </Grid>
                <Grid key="timeSetting" item xs={12} sm={2}>
                  <Field
                    id="timeSetting"
                    name="timeSetting"
                    component={renderTextField}
                    className="fields"
                    label=""
                    required={true}
                    onChange={this.textChange}
                    type={'time'}
                    fullWidth
                    InputProps={{
                      readOnly: isReadOnly,
                    }}
                    validate={[
                    ]}
                  />
                </Grid>
              </Grid>}
              {!isTextarea && !isDateTime && <Grid container
                justifyContent="flex-start"
                alignItems="flex-end"
                spacing={1}
              >
                <Grid key="setting" item xs={12} sm={4}>
                  <Field
                    id="setting"
                    name="setting"
                    component={renderTextField}
                    className="fields"
                    label="設定値"
                    required={true}
                    onChange={this.textChange}
                    type={this.type}
                    fullWidth
                    InputProps={{
                      readOnly: isReadOnly,
                    }}
                    validate={[
                    ]}
                  />
                </Grid>
              </Grid>}

              {isTextarea && <Grid container
                justifyContent="flex-start"
                alignItems="flex-end"
                spacing={1}
              >
                <Grid key="setting" item xs={12} sm={4} >
                  <Field
                    id="setting"
                    name="setting"
                    component={renderTextField}
                    className="fields"
                    onChange={this.textChange}
                    label="設定値"
                    required={true}
                    type={this.type}
                    fullWidth
                    InputProps={{
                      readOnly: isReadOnly,
                    }}
                    validate={[
                    ]}
                    multiline={true}
                    rows={10}
                    onKeyUp={(e) => {
                      this.setPreview(e.target.textContent);
                    }}
                  />
                </Grid>
                {_mstData.valueType === 5 && <Grid key="preview" item xs={12} sm={6}>
                  {this.state.preview}
                </Grid>}

              </Grid>}
            </Grid>

            <Grid container
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={1}
            >
              <Grid key="description" item xs={12} sm={6}>
                <Field
                  id="description"
                  name="description"
                  component={renderTextField}
                  className="fields"
                  onChange={this.textChange}
                  InputProps={{
                    readOnly: isReadOnly,
                  }}
                  label="説明"
                  fullWidth
                  validate={[
                  ]}
                />
              </Grid>
            </Grid>
            <Grid container
              justifyContent="flex-start"
              alignItems="flex-end"
              spacing={1}
            >
              <Grid key="startYmd" item xs={12} sm={2}>
                <Field
                  id="startYmd"
                  name="startYmd"
                  component={renderTextField}
                  className="fields"
                  label="適用開始年月日"
                  onChange={this.textChange}
                  InputProps={{
                    readOnly: isReadOnly||this.state.isStartEndReadOnly,
                  }}
                  fullWidth
                  type={'date'}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  validate={[
                  ]}
                />
              </Grid>
              <Grid key="endYmd" item xs={12} sm={2}>
                <Field
                  id="endYmd"
                  name="endYmd"
                  component={renderTextField}
                  className="fields"
                  label="適用終了年月日"
                  onChange={this.textChange}
                  InputProps={{
                    readOnly: isReadOnly||this.state.isStartEndReadOnly,
                  }}
                  fullWidth
                  type={'date'}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  validate={[
                  ]}
                />
              </Grid>
              <Grid key="isIndefinite" item xs={12} sm={2}>
                <FormControl component="fieldset" className='classes.formControl'>
                  <FormGroup row={true}>
                    <Field className='classes.checkbox'
                      id="isIndefinite"
                      name="isIndefinite"
                      component={renderCheckbox}
                      disabled={isReadOnly}
                      label={<p style={{margin: '0px 0px 15px 0px'}}>
                      無期限
                      </p>}
                      onChange={this.chechBoxChange}
                      validate={[]}
                      sx={{margin: '0px 0px 15px 30px'}}
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
            </Grid>
          </PaperPart>
        </MainContainer>
      </form>
    );
  }
}

Container.propTypes = {
  classes: PropTypes.object,
  history: PropTypes.object,
  values: PropTypes.object,
  reset: PropTypes.func,
  handleSubmit: PropTypes.func,
  doShowMessage: PropTypes.func,
  doSetInitValues: PropTypes.func,
  genericMap: PropTypes.object,
  navigate: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    genericMap: state.common.generalPurposeMap,
    initialValues: state.common.setInitValues,
  };
};

const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
  doSetInitValues: commonOperations.doSetInitValues,
};

const FORM_NAME = 'CO002Form';

Container = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(Container));

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(Container)),
);
